/**
 * useModalManagement Hook
 *
 * Unified modal management system that combines:
 * - Modal navigation functionality
 * - Modal actions (favorite, delete)
 * - Modal state management
 * - Integration with existing modal components
 */

import { useModalNavigation } from './useModalNavigation'
import { useModalActions } from './useModalActions'

export const useModalManagement = () => {
  // Import navigation functions
  const {
    handleModalArrowClick,
    handleModalStatusChange,
    handleModalOpen,
    handleModalClose,
    getSortedAssets,
    getAssetDate
  } = useModalNavigation()

  // Import action functions
  const {
    handleMakeFavorite,
    handleDeleteAsset,
    getActionVisibility,
    getAssetId
  } = useModalActions()

  // Combined modal management interface
  return {
    // Navigation functions
    handleModalArrowClick,
    handleModalStatusChange,
    handleModalOpen,
    handleModalClose,
    getSortedAssets,
    getAssetDate,

    // Action functions
    handleMakeFavorite,
    handleDeleteAsset,
    getActionVisibility,
    getAssetId
  }
}

export default useModalManagement
